<template>
    <button @click="reset()" type="button" class="btn btn-sm btn-success btn-block">
        <li class="fa fa-recycle"></li> SZCS#GPS_DISSLP=1
    </button>
</template>
<script>
    import {Comandos} from '../../class';
    import {Bus} from '../../class/bus';
    export default {
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async reset () {
                await Comandos.habiliarEconomia(this.id_rastreador, true);
                Bus.$emit('comandos');
            }
        }
    }
</script>
